// Setup dev api
const devHost = process.env.VUE_APP_API_DEV_HOST || 'localhost'
const devPort = process.env.VUE_APP_API_DEV_PORT || 5000
const devRoot = process.env.VUE_APP_API_DEV_ROOT || '/api/v1'
const devURL = `http://${devHost}:${devPort}${devRoot}`

const baseURL = process.env.NODE_ENV === 'production' ? '/api/v1' : devURL

/**
 * Api blueprint base class
 */
export class Base
{
	/// Vuex store used to retrieve
	/// access token
	_store = null

	/**
	 * Empty default constructor
	 * 
	 * @param {VuexStore} store vuex instance
	 */
	constructor(store)
	{
		this._store = store
	}

	/**
	 * Issue a get request 
	 *
	 * @param {String} endpoint api endpoint
	 * @param {object} params query parameters
	 * @param {object} headers optional headers
	 */
	async _get(endpoint, params = {}, headers = {}) {

		const session = this._store.getters['auth/session']
		if (session)
			// Append authorization header
			headers['Authorization'] = 'Bearer ' + session.access_token

		// Build query string
		const queryString = Object.keys(params).map((p) => `${p}=${params[p]}`).join('&')

		// Send request
		const res = await fetch(baseURL + endpoint + (queryString ? '?' + queryString : ''), {
			method: 'GET',
			//mode: 'same-origin',
			headers
		})

		const json = await res.json()

		if (res.ok)
			// Return response body
			return json
		else
			// Throw error with response
			throw json
	}

	/**
	 * 
	 * @param {String} endpoint api endpoint url
	 * @param {*} data post payload
	 * @param {object} headers optional headers
	 */
	async _post(endpoint, data, bJson = false, headers = {}) {

		const session = this._store.getters['auth/session']
		if (session)
			// Append authorization header
			headers['Authorization'] = 'Bearer ' + session.access_token
		
		// Process data
		let body = data
		if (bJson)
		{
			// Send body as json
			headers['Content-Type'] = 'application/json'
			body = JSON.stringify(data)
		}
		else
			// Send as url encoded
			body = new URLSearchParams(data)
	
		const res = await fetch(baseURL + endpoint, {
			method: 'POST',
			//mode: 'same-origin',
			body,
			headers
		})
	
		const json = await res.json()

		if (res.ok)
			// Return response body
			return json
		else
			// Throw error with response
			throw json
	}

	/**
	 * 
	 * @param {String} endpoint api endpoint url
	 * @param {*} data post payload
	 * @param {object} headers optional headers
	 */
	async _put(endpoint, data, bJson = false, headers = {}) {

		const session = this._store.getters['auth/session']
		if (session)
			// Append authorization header
			headers['Authorization'] = 'Bearer ' + session.access_token
		
		// Process data
		let body = data
		if (bJson)
		{
			// Send body as json
			headers['Content-Type'] = 'application/json'
			body = JSON.stringify(data)
		}
		else
			// Send as url encoded
			body = new URLSearchParams(data)
	
		const res = await fetch(baseURL + endpoint, {
			method: 'PUT',
			//mode: 'same-origin',
			body,
			headers
		})
	
		const json = await res.json()

		if (res.ok)
			// Return response body
			return json
		else
			// Throw error with response
			throw json
	}

	/**
	 * Issue a get request 
	 *
	 * @param {String} endpoint api endpoint
	 * @param {object} params query parameters
	 * @param {object} headers optional headers
	 */
	async _delete(endpoint, params = {}, headers = {}) {

		const session = this._store.getters['auth/session']
		if (session)
			// Append authorization header
			headers['Authorization'] = 'Bearer ' + session.access_token

		// Build query string
		const queryString = Object.keys(params).map((p) => `${p}=${params[p]}`).join('&')

		// Send request
		const res = await fetch(baseURL + endpoint + (queryString ? '?' + queryString : ''), {
			method: 'DELETE',
			//mode: 'same-origin',
			headers
		})

		const json = await res.json()

		if (res.ok)
			// Return response body
			return json
		else
			// Throw error with response
			throw json
	}
}
